import { InjectionToken } from '@angular/core';

export const CURRENT_LANG = new InjectionToken('CurrentLanguage');
